import { Plugin } from "chart.js";

const HIGHLIGHT_COLOR = "rgba(251, 57, 115, 0.08)";

// wider than the widest bar (24px), but never the whole chart when
// there are only a few columns
const MAX_BAND_WIDTH = 72;

// Draws a vertical band behind the selected day — the one whose variant
// breakdown is shown in the table below the chart.
export const selectedDayPlugin: Plugin<"bar" | "line"> = {
  id: "selectedDay",
  beforeDatasetsDraw: (chart, _args, options) => {
    const index = options?.index;
    const labelsCount = chart.data.labels?.length ?? 0;

    if (index === null || index === undefined) return;
    if (index < 0 || index >= labelsCount) return;

    const xScale = chart.scales.x;
    if (!xScale) return;

    const { ctx, chartArea } = chart;
    const center = xScale.getPixelForValue(index);
    const columnWidth =
      labelsCount > 1
        ? Math.abs(xScale.getPixelForValue(1) - xScale.getPixelForValue(0))
        : MAX_BAND_WIDTH;
    const bandWidth = Math.min(columnWidth, MAX_BAND_WIDTH);

    const left = Math.max(chartArea.left, center - bandWidth / 2);
    const right = Math.min(chartArea.right, center + bandWidth / 2);

    ctx.save();
    ctx.fillStyle = HIGHLIGHT_COLOR;
    ctx.fillRect(left, chartArea.top, right - left, chartArea.height);
    ctx.restore();
  }
};
